import { InfoCircleOutlined } from "@ant-design/icons";
import { toast, Zoom } from "react-toastify";

export const showToast = (message, delay = 3000) => {
    toast.success(message, {
        position: 'bottom-center',
        autoClose: delay,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        transition: Zoom,
    });
};

export const warningToast = (message, delay = 3000) => {
    toast.warning(message, {
        position: 'bottom-center',
        autoClose: delay,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        transition: Zoom,
    });
};

export const errorToast = (message, delay = 3000) => {
    toast.error(message, {
        position: 'bottom-center',
        autoClose: delay,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        transition: Zoom,
    });
};

export const kioskErrorToast = (title, subtitle, icon = <InfoCircleOutlined />, delay = 3500) => {
    toast.error(
        <div>
            <div className="kiosk-modern-toast-title">{title}</div>
            <div className="kiosk-modern-toast-subtitle">{subtitle}</div>
        </div>,
        {
            position: 'bottom-center',
            autoClose: delay,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            transition: Zoom,
            icon: icon,
            className: 'kiosk-modern-toast',
        }
    );
};